import ProductListContainer from "../../../../Components/Applications/ECommerce/ProductList/ProductListContainer";

const ProductList = () => {
  return <ProductListContainer />;
};

export default ProductList;
